/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown>, table: NonNullable<unknown> }} Rounds_Seating_MovedInputs */



/**
* | output |
* | --- |
* | "Moved {name} to {table}" |
*
* @param {Rounds_Seating_MovedInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const rounds_seating_moved = /** @type {((inputs: Rounds_Seating_MovedInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rounds_Seating_MovedInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`${i?.name} déplacé(e) vers ${i?.table}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`${i?.name} movido/a a ${i?.table}`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`${i?.name} movido/a para ${i?.table}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`${i?.name} spostato/a a ${i?.table}`)
	return /** @type {LocalizedString} */ (`Moved ${i?.name} to ${i?.table}`)
});